(function () {
  "use strict";
  var doc = document;
  var reduced =
    typeof window.matchMedia === "function" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  function build(root) {
    var track =
      root.querySelector("[data-xg-scroll-track]") ||
      root.querySelector(".xg-scroller");
    if (!track) return null;
    var prev = root.querySelector('[data-xg-scroll="prev"]');
    var next = root.querySelector('[data-xg-scroll="next"]');
    function sync() {
      var max = track.scrollWidth - track.clientWidth;
      var left = track.scrollLeft;
      var fits = max <= 1;
      var offPrev = fits || left <= 1;
      var offNext = fits || left >= max - 1;
      var active = doc.activeElement;
      root.setAttribute("data-xg-state", fits ? "fits" : "scrolls");
      if (offNext && !offPrev && active === next && prev) prev.focus();
      else if (offPrev && !offNext && active === prev && next) next.focus();
      if (prev) prev.disabled = offPrev;
      if (next) next.disabled = offNext;
    }
    function page(direction) {
      track.scrollBy({
        left: direction * track.clientWidth * 0.9,
        behavior: reduced ? "instant" : "smooth"
      });
    }
    if (prev) prev.addEventListener("click", function () { page(-1); });
    if (next) next.addEventListener("click", function () { page(1); });
    var queued = false;
    track.addEventListener(
      "scroll",
      function () {
        if (queued) return;
        queued = true;
        window.requestAnimationFrame(function () {
          queued = false;
          sync();
        });
      },
      { passive: true }
    );
    sync();
    return sync;
  }
  var syncs = [];
  function prune() {
    for (var i = syncs.length - 1; i >= 0; i -= 1) {
      if (!doc.contains(syncs[i].root)) syncs.splice(i, 1);
    }
  }
  function init(scope) {
    prune();
    var roots = (scope || doc).querySelectorAll("[data-xg-scroller]");
    for (var i = 0; i < roots.length; i += 1) {
      var root = roots[i];
      if (root.hasAttribute("data-xg-scroller-ready")) continue;
      root.setAttribute("data-xg-scroller-ready", "");
      var sync = build(root);
      if (sync) syncs.push({ root: root, sync: sync });
    }
  }
  function syncAll() {
    prune();
    for (var i = 0; i < syncs.length; i += 1) syncs[i].sync();
  }
  init(doc);
  doc.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });
  doc.addEventListener("shopify:section:unload", prune);
  var pending = false;
  window.addEventListener(
    "resize",
    function () {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(function () {
        pending = false;
        syncAll();
      });
    },
    { passive: true }
  );
  doc.addEventListener("xg:tabchange", syncAll);
  window.XG = window.XG || {};
  window.XG.scroller = {
    init: init,
    sync: syncAll,
    live: function () { prune(); return syncs.length; }
  };
})();
